/* unplugin-vue-components disabled */import { render } from "./UserListItem.vue?vue&type=template&id=35d63803&scoped=true&ts=true"
import script from "./UserListItem.vue?vue&type=script&lang=ts"
export * from "./UserListItem.vue?vue&type=script&lang=ts"

import "./UserListItem.vue?vue&type=style&index=0&id=35d63803&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35d63803"]])

export default __exports__